import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { downloadCsv } from "@/lib/csv";

/** Geteilter CSV-Export-Button (Welle 2, #10): baut das CSV erst beim Klick (build),
 *  haengt das Tagesdatum an den Dateinamen und loest den Browser-Download aus. */
export function ExportCsvButton({
  filename,
  build,
  disabled,
}: {
  filename: string;
  build: () => string;
  disabled?: boolean;
}) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="gap-1.5"
      disabled={disabled}
      aria-label={`CSV-Export ${filename}`}
      onClick={() => downloadCsv(`${filename}_${new Date().toISOString().slice(0, 10)}.csv`, build())}
    >
      <Download className="size-3.5" />
      CSV
    </Button>
  );
}
